import _ from 'lodash'
import {buildHorizontalLine} from './build_horizontal_line'
import {buildPopout} from './build_popout'
import {buildToolBar} from './build_toolbar'
import {t} from '@eitje/bridge'
import {Colors} from '@eitje/assets'
import {LINE_COLORS, FONT_FAMILY} from '../constants'
import {handleZoomState} from './handle_zoom_state'
import {useCallback, useMemo} from 'react'

export const useApexOptions = ({layoutRef, popoutProps, horizontalLine = {}, apexOptions = {}, formatX, formatY, series, graphName}) => {
	const {formatTitle, formatSeriesLabel, formatSeriesValue, ExtraContent} = popoutProps || {}
	const showPopout = !!popoutProps

	// React ApexCharts compares nested functions by reference; keep these stable so series-only changes use updateSeries.
	const chartEvents = useMemo(() => handleZoomState(layoutRef), [layoutRef])
	const tooltip = useMemo(
		() => buildPopout({showPopout, formatTitle, formatSeriesLabel, formatSeriesValue, ExtraContent}),
		[showPopout, formatTitle, formatSeriesLabel, formatSeriesValue, ExtraContent],
	)
	const formatXLabel = useCallback(value => (formatX ? formatX(value) : value), [formatX])
	const formatYLabel = useCallback(value => (formatY ? formatY(value) : value), [formatY])

	const defaultOptions = {
		noData: {text: t('common.loading')},
		stroke: {curve: 'smooth', width: 4},
		grid: {borderColor: Colors.lightBorder, strokeDashArray: 4},
		chart: {
			toolbar: buildToolBar({series, graphName}),
			events: chartEvents,
			fontFamily: FONT_FAMILY,
			animations: {dynamicAnimation: {speed: 800}},
		},
		legend: {fontFamily: FONT_FAMILY, fontSize: '14px'},
		annotations: buildHorizontalLine(horizontalLine),
		tooltip,
		xaxis: {
			labels: {formatter: formatXLabel, style: {fontSize: '14px'}},
			tooltip: {style: {fontSize: '14px'}, offsetY: -4},
		},
		yaxis: {labels: {formatter: formatYLabel, style: {fontSize: '14px'}}},
		colors: LINE_COLORS,
	}

	return _.merge({}, defaultOptions, apexOptions)
}
